<template>
    <div class="bo-return-popup">
        <div
            class="modal-backdrop fade show"
            v-if="showPopup && popupProduct"
        ></div>
        <div
            v-if="showPopup && popupProduct"
            :id="modalId"
            :class="['modal bo-modal']"
            tabindex="-1"
            role="dialog"
            :aria-labelledby="modalId"
            style="display: block"
        >
            <div
                :class="['modal-dialog modal-dialog-centered full-width has-table']"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="return-item-info">
                            <div class="left-panel">
                                <img
                                    :src="getProductImage(popupProduct.images)"
                                    alt="Img"
                                    height="36px"
                                    width="36px"
                                />
                                <div class="item-info">
                                    <span class="sku">
                                        {{ popupProduct.sku }}
                                    </span>
                                    <span class="name">
                                        {{ popupProduct.name }}
                                    </span>
                                </div>
                            </div>
                            <div class="right-panel">
                                <i
                                    class="icon-close"
                                    @click="closePopup"
                                ></i>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="table-content">
                            <bo-datatable
                                :editable="true"
                                :select-multiple="!cartMode"
                                :enable-edit-record="false"
                                :display-title-header="false"
                                :columns="returnDetailColumns"
                                :records="returnDetails"
                                :pagination="returnDetailsPagination"
                                :local-search-sort="!isDocumentBinding"
                                :primary-color="primaryColor"
                                @select_change_uom="returnDetailChangeUom"
                                @text_change_serial_number_not_transfered="returnDetailChangeSerialNumber"
                                @modify="returnDetailChange"
                                @get_data="loadLineItems"
                                @generic="
                                    boGenericHandler(
                                        { columns: returnDetailColumns, records: returnDetails },
                                        ...arguments
                                    )
                                "
                            >
                                <!-- @select_multiple_records="selectCompany"
                            @mounted="fetchWarehousesIfNeeded"
                            @get_data="fetchWarehouses" -->
                                <template #quantity_column="quantitySlotProps">
                                    <span
                                        v-if="
                                            quantitySlotProps.record.serial_number_not_transfered != null &&
                                            quantitySlotProps.record.serial_number_not_transfered != ''
                                        "
                                        >{{ quantitySlotProps.record.quantity }}
                                    </span>
                                    <bo-cell-number
                                        v-else-if="isDocumentBinding"
                                        :min="0"
                                        :max="quantitySlotProps.record.lineItem.untransferred_quantity"
                                        :editable="true"
                                        :display-max="true"
                                        v-model="returnDetails[quantitySlotProps.record.id].quantity"
                                        @input="returnDetailChangeQuntity(quantitySlotProps.record.id, ...arguments)"
                                    >
                                    </bo-cell-number>
                                </template>
                                <template #discount_column="discountSlotProps">
                                    <bo-line-discount
                                        class="bo-line-discount--table"
                                        :steps="getReturnDiscountSteps(discountSlotProps.record)"
                                    ></bo-line-discount>
                                </template>
                                <template #action_column="actionSlotProps">
                                    <div @click="deleteRow(actionSlotProps.record.id)">
                                        <i class="icon-deleteforever remove"></i>
                                    </div>
                                </template>
                                <template
                                    v-if="!(isDocumentBinding || cartMode)"
                                    slot="footer"
                                >
                                    <div class="add-product">
                                        <div
                                            class="btn-add-product"
                                            @click="addNewRow(indexCounter++)"
                                        >
                                            <i class="icon-add"></i>
                                            {{
                                                generalTranslations?.add_object?.replace(
                                                    ":object",
                                                    catalogTranslations?.return
                                                ) ?? "Add Return"
                                            }}
                                        </div>
                                    </div>
                                </template>
                            </bo-datatable>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div
                            v-if="!cartMode"
                            class="left-panel"
                        >
                            <div class="footer-info">
                                {{ generalTranslations?.selected ?? "Selected" }}
                                <span>
                                    {{ selectedReturnDetailNumber }}
                                    {{ generalTranslations?.items ?? "Items" }}
                                </span>
                            </div>
                            <div
                                class="footer-info"
                                v-if="canReadPrices"
                            >
                                {{ catalogTranslations?.total ?? "Total" }}
                                <span>
                                    {{ currencySymbol ?? "RM" }}
                                    {{ roundToDecimal(returnPopupTotal, 2, true) }}
                                </span>
                            </div>
                        </div>
                        <div class="right-panel">
                            <button
                                v-if="isDocumentBinding && !cartMode"
                                class="btn-rounded btn-primary danger"
                                @click="toNormalMode"
                            >
                                {{ catalogTranslations?.bypass_doc ?? "Bypass Document" }}
                            </button>
                            <button
                                v-if="!cartMode"
                                class="btn-rounded btn-primary btn-confirm"
                                :disabled="selectedReturnDetailNumber == 0"
                                @click="confirm"
                            >
                                {{ generalTranslations?.confirm ?? "Confirm" }} ({{ selectedReturnDetailNumber }})
                            </button>
                            <button
                                v-else
                                class="btn-rounded btn-primary btn-confirm"
                                @click="confirm"
                            >
                                {{ generalTranslations?.confirm ?? "Confirm" }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
Vue.component("bo-popup-modal", require("@/v2/components/bo-popup-modal.vue").default);
Vue.component("bo-datatable", require("@/v2/components/bo-datatable.vue").default);
Vue.component("bo-cell-number", require("@/v2/components/bo-cell-number.vue").default);
Vue.component("bo-line-discount", require("js/frontend/components/bo-line-discount.vue").default);
Vue.component(
    "bo-cell-mode-input-number",
    require("@/v2/components/bo-datatable/bo-cell-mode-input-number.vue").default
);

import productMixin from "@/v2/mixins/products.js";
import cartMixin from "@/v2/mixins/carts.js";
import documentsMixin from "@/v2/mixins/documents.js";
import { boDatatableMixin } from "@/v2/mixins/bo-datatable.js";
import { Record } from "@/v2/models/bo-datatable.js";
import { VariableProduct, VariationProduct } from "@/v2/models/products";
import { priceVisibilityMixin, filterCatalogPriceColumns } from "js/frontend/mixins/price-visibility.js";
import { formatLineDiscountSteps, documentLineDiscountSteps } from "js/frontend/utils/line-discount-label.js";

export default {
    mixins: [productMixin, documentsMixin, cartMixin, boDatatableMixin, priceVisibilityMixin],
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        product: {
            type: Object,
            default: () => {
                return {};
            },
        },
        serialNumber: {
            type: String,
            default: null,
        },
        salesReturnValidationMode: {
            type: String,
            default: null,
        },
        returnReasonOptions: {
            type: [Array, Object],
            default: () => {
                return {};
            },
        },
        returnReasonLabels: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isBatchEnable: {
            type: Boolean,
            default: false,
        },
        isSerialNumberEnable: {
            type: Boolean,
            default: false,
        },
        documentLineItemUrl: {
            type: String,
        },
        cartUrl: {
            type: String,
            default: null,
        },
        productUrl: {
            type: String,
            default: null,
        },
        cartId: {
            type: Number,
            default: null,
        },
        outletId: {
            type: String,
            default: null,
        },
        companyId: {
            type: Number,
            default: null,
        },
        cartMode: {
            type: Boolean,
            default: false,
        },
        cartItem: {
            type: Object,
            default: () => {
                return {};
            },
        },
        tradeAgreementUrl: {
            type: String,
            default: null,
        },
        generalTranslations: {
            type: Object,
            default: () => window.bo?.generalTranslations ?? null,
        },
        catalogTranslations: {
            type: Object,
            default: () => window.bo?.catalogTranslations ?? null,
        },
        currencySymbol: {
            type: String,
            default: () => window.bo?.currencySymbol ?? "RM",
        },
    },

    data() {
        return {
            primaryColor: window.bo_primary_color || '#594c45',
            returnDetailsPagination: null,
            showPopup: this.active,
            selectedDetails: [],
            isBypassBinding: false,
            indexCounter: 0,
            popupProduct: null,
            returnDetails: {},
            productUomOptions: [],
            productUomLabels: {},
            returnDetailColumns: this.boDatatableProcessColumns(filterCatalogPriceColumns([
                {
                    id: "id",
                    label: this.catalogTranslations.id ?? "ID",
                    disabled: true,
                    type: "text",
                    primary_key: true,
                },
                {
                    id: "price",
                    label: this.catalogTranslations.price ?? "Unit Price (RM)",
                    type: "number",
                    orderable: false,
                    searchable: false,
                    decimal: 2,
                    transformer: (record) => {
                        if (this.isDocumentBinding) {
                            return (
                                this.addOrRemoveTaxIfNeeded(record.lineItem.subtotal, record.tax_class) /
                                record.lineItem.quantity
                            );
                        } else {
                            return record.price;
                        }
                    },
                },
                {
                    id: "tax_name",
                    label: this.catalogTranslations.tax_name ?? "Tax Class",
                    type: "text",
                    orderable: true,
                    searchable: false,
                    transformer: (record) => {
                        return record.tax_class?.visible ? record.tax_class?.name : "";
                    },
                },
                {
                    id: "tax_percentage",
                    label: this.catalogTranslations.tax_percentage ?? "Tax ",
                    type: "text",
                    orderable: true,
                    searchable: false,
                    editable: false,
                    transformer: (record) => {
                        return record.tax_class?.visible ? record.tax_class.percentage + "%" : "";
                    },
                },
                {
                    id: "uom",
                    label: this.catalogTranslations.uom ?? "UOM",
                    type: "select",
                    nullText: "Select",
                    orderable: true,
                    searchable: false,
                    editable: this.salesReturnValidationMode != "document_binding",
                    options: this.productUomOptions,
                    labels: this.productUomLabels,
                },
                {
                    id: "quantity",
                    label: this.catalogTranslations.quantity ?? "Return",
                    type: "number",
                    orderable: false,
                    searchable: false,
                    editable: true,
                    min: 0,
                    max: Number.MAX_SAFE_INTEGER,
                    negative: false,
                },
                {
                    id: "discount",
                    label: this.catalogTranslations.discount ?? "Discount",
                    type: "custom",
                    orderable: false,
                    editable: false,
                    searchable: false,
                },
                {
                    id: "effective_unit_price",
                    label: this.catalogTranslations.effective_unit_price ?? "Unit Price After Discount",
                    type: "number",
                    decimal: 2,
                    orderable: false,
                    editable: false,
                    searchable: false,
                    transformer: (record) => {
                        if (record.quantity > 0) {
                            return record.subtotal / record.quantity;
                        } else if (record.discount_type) {
                            return record.price;
                        }
                        return 0.0;
                    },
                },
                {
                    id: "subtotal",
                    label: this.catalogTranslations.subtotal ?? "Subtotal (RM)",
                    type: "number",
                    orderable: false,
                    searchable: false,
                    decimal: 2,
                },
                {
                    id: "return_reason",
                    label: this.catalogTranslations.return_reason ?? "Return Reason",
                    type: "select",
                    nullText: this.generalTranslations.select ?? "Select",
                    orderable: false,
                    searchable: false,
                    editable: true,
                    options: this.returnReasonOptions,
                    labels: this.returnReasonLabels,
                },
                {
                    id: "remark",
                    label: this.catalogTranslations.remark ?? "Remark",
                    type: "text",
                    orderable: false,
                    searchable: false,
                    editable: true,
                },
                {
                    id: "batch",
                    label: this.catalogTranslations.batch ?? "Batch",
                    type: "text",
                    orderable: true,
                    editable: this.salesReturnValidationMode != "document_binding",
                    disabled: !this.isBatchEnable,
                },
                {
                    id: "serial_number_not_transfered",
                    label: this.catalogTranslations.serial_number_not_transferred ?? "Serial Number",
                    type: "text",
                    orderable: true,
                    editable: this.salesReturnValidationMode != "document_binding",
                    disabled: !this.isSerialNumberEnable,
                },
                {
                    id: "document_number",
                    label: this.catalogTranslations.document_number ?? "Document Number",
                    type: "text",
                    orderable: true,
                    editable: false,
                    disabled: this.salesReturnValidationMode != "document_binding",
                },
                {
                    id: "document_date",
                    label: this.catalogTranslations.document_date ?? "Document Date",
                    type: "datetime",
                    orderable: true,
                    editable: false,
                    searchable: true,
                    format: "DD-MMM-YYYY",
                    disabled: this.salesReturnValidationMode != "document_binding",
                    transformer: (record) => {
                        return record.lineItem.document_date;
                    },
                },
                {
                    id: "action",
                    label: this.generalTranslations.action ?? "Action",
                    type: "custom",
                    orderable: false,
                    searchable: false,
                    disabled: this.salesReturnValidationMode == "document_binding",
                },
            ])),
            lineItemCustomDiscountEnabled: false,
        };
    },
    watch: {
        active: function (n, o) {
            document.body.classList.toggle("modal-open");
            this.showPopup = n;
            if (this.showPopup == true) {
                this.activate();
            }
        },

        popupProduct: function (n, o) {
            if (typeof n != "undefined" && this.isDocumentBinding == false && !this.cartMode) {
                this.addNewRow(this.indexCounter++);
            }
        },
    },
    mounted() {
        // this.popupProduct = this.product;
        if (this.salesReturnValidationMode == "document_binding") {
            this.columns;
        }
    },
    computed: {
        isTaxIncluded: {
            get() {
                return window.bo.taxIncluded;
            },
        },
        isDisplayPricesDuringCartAndCheckoutIncludingTax: {
            get() {
                return window.bo.displayPricesDuringCartAndCheckoutIncludingTax;
            },
        },
        isTaxExempted: {
            get() {
                return window.bo.taxExempted;
            },
        },
        discountTypes: {
            get() {
                return window.bo.discountTypes;
            },
        },
        defaultDiscountType: {
            get() {
                return window.bo.discountTypes["percentage"];
            },
        },
        modalId: {
            get() {
                return this.id ?? `bo-return-popup_${uuidv4()}`;
            },
        },
        returnPopupTotal: function returnPopupTotal() {
            let total = 0;
            Object.values(this.returnDetails).forEach((row) => {
                if (row.checked && row.quantity > 0) {
                    total += row.subtotal;
                }
            });
            return total;
        },
        selectedReturnDetailNumber: function selectedReturnDetailNumber() {
            let number = 0;
            Object.values(this.returnDetails).forEach((row) => {
                if (row.checked && row.quantity > 0) {
                    number++;
                }
            });
            return number;
        },
        isDocumentBinding: function isDocumentBinding() {
            if (this.salesReturnValidationMode == "document_binding") {
                if (this.isBypassBinding) {
                    return false;
                }
                return true;
            }
            return false;
        },
    },

    methods: {
        activate() {
            this.returnDetails = {};

            if (this.cartMode) {
                this.popupProduct = this.cartItem.product;

                this.productUomOptions = [];
                this.productUomLabels = {};
                if (this.popupProduct instanceof VariableProduct) {
                    Object.values(this.popupProduct.uom).forEach((uom) => {
                        this.productUomLabels[uom.slug] = uom.name;
                        this.productUomOptions.push(uom.slug);
                    });
                } else {
                    this.productUomOptions = [this.popupProduct.uom.slug];
                    this.productUomLabels[this.popupProduct.uom.slug] = this.popupProduct.uom.name;
                }

                this.returnDetailColumns = this.boDatatableProcessColumns(filterCatalogPriceColumns([
                    {
                        id: "id",
                        label: window.bo?.catalogTranslations?.id ?? "ID",
                        disabled: true,
                        type: "text",
                        primary_key: true,
                    },
                    {
                        id: "price",
                        label: window.bo?.catalogTranslations?.price ?? "Unit Price (RM)",
                        type: "number",
                        orderable: false,
                        searchable: false,
                        decimal: 2,
                        transformer: (record) => {
                            if (this.isDocumentBinding) {
                                return (
                                    this.addOrRemoveTaxIfNeeded(record.lineItem.subtotal, record.tax_class) /
                                    record.lineItem.quantity
                                );
                            } else {
                                return record.price;
                            }
                        },
                    },
                    {
                        id: "tax_name",
                        label: window.bo?.catalogTranslations?.tax_name ?? "Tax Class",
                        type: "text",
                        orderable: true,
                        searchable: false,
                        transformer: (record) => {
                            return record.tax_class?.visible ? record.tax_class?.name : "";
                        },
                    },
                    {
                        id: "tax_percentage",
                        label: window.bo?.catalogTranslations?.tax_percentage ?? "Tax ",
                        type: "text",
                        orderable: true,
                        searchable: false,
                        editable: false,
                        transformer: (record) => {
                            return record.tax_class?.visible ? record.tax_class.percentage + "%" : "";
                        },
                    },
                    {
                        id: "uom",
                        label: window.bo?.catalogTranslations?.uom ?? "UOM",
                        type: "select",
                        nullText: "Select",
                        orderable: true,
                        searchable: false,
                        editable: this.salesReturnValidationMode != "document_binding",
                        options: this.productUomOptions,
                        labels: this.productUomLabels,
                    },
                    {
                        id: "quantity",
                        label: window.bo?.catalogTranslations?.quantity ?? "Return",
                        type: "number",
                        orderable: false,
                        searchable: false,
                        editable: true,
                        min: 0,
                        max: Number.MAX_SAFE_INTEGER,
                        negative: false,
                    },
                    {
                        id: "discount",
                        label: window.bo?.catalogTranslations?.discount ?? "Discount",
                        type: "custom",
                        orderable: false,
                        editable: false,
                        searchable: false,
                    },
                    {
                        id: "effective_unit_price",
                        label: window.bo?.catalogTranslations?.effective_unit_price ?? "Unit Price After Discount",
                        type: "number",
                        decimal: 2,
                        orderable: false,
                        editable: false,
                        searchable: false,
                        transformer: (record) => {
                            if (record.quantity > 0) {
                                return record.subtotal / record.quantity;
                            } else if (record.discount_type) {
                                return record.price;
                            }
                            return 0.0;
                        },
                    },
                    {
                        id: "subtotal",
                        label: window.bo?.catalogTranslations?.subtotal ?? "Subtotal (RM)",
                        type: "number",
                        orderable: false,
                        searchable: false,
                        decimal: 2,
                    },
                    {
                        id: "return_reason",
                        label: window.bo?.catalogTranslations?.return_reason ?? "Return Reason",
                        type: "select",
                        nullText: "Select",
                        orderable: false,
                        searchable: false,
                        editable: true,
                        options: this.returnReasonOptions,
                        labels: this.returnReasonLabels,
                        nullText: "Select",
                    },
                    {
                        id: "remark",
                        label: window.bo?.catalogTranslations?.remark ?? "Remark",
                        type: "text",
                        orderable: false,
                        searchable: false,
                        editable: true,
                    },
                    {
                        id: "batch",
                        label: window.bo?.catalogTranslations?.batch ?? "Batch",
                        type: "text",
                        orderable: true,
                        editable: this.salesReturnValidationMode != "document_binding",
                        disabled: !this.isBatchEnable,
                    },
                    {
                        id: "serial_number_not_transfered",
                        label: window.bo?.catalogTranslations?.serial_number_not_transferred ?? "Serial Number",
                        type: "text",
                        orderable: true,
                        editable: this.salesReturnValidationMode != "document_binding",
                        disabled: !this.isSerialNumberEnable,
                    },
                    {
                        id: "document_number",
                        label: window.bo?.catalogTranslations?.document_number ?? "Document Number",
                        type: "text",
                        orderable: true,
                        editable: false,
                        disabled: this.salesReturnValidationMode != "document_binding",
                    },
                    {
                        id: "document_date",
                        label: window.bo?.catalogTranslations?.document_date ?? "Document Date",
                        type: "datetime",
                        orderable: true,
                        editable: false,
                        searchable: true,
                        format: "DD-MMM-YYYY",
                        disabled: this.salesReturnValidationMode != "document_binding",
                        transformer: (record) => {
                            return record.lineItem.document_date;
                        },
                    },
                    {
                        id: "action",
                        label: window.bo?.generalTranslations?.action ?? "Action",
                        type: "custom",
                        orderable: false,
                        searchable: false,
                        disabled: this.salesReturnValidationMode == "document_binding",
                    },
                ]));

                if (this.isDocumentBinding && this.cartItem.line_item_id == null) {
                    this.toNormalMode();
                }
                this.loadCartItem(this.cartItem);
            } else if (this.isDocumentBinding) {
                this.popupProduct = this.getProductData(this.product.id);

                let payload = {
                    params: {},
                };
                if (this.serialNumber != null) {
                    this.returnDetailColumns.serial_number_not_transfered.search = this.serialNumber;
                    payload.params["serial_number_not_transfered"] = this.serialNumber;
                }
                this.loadLineItems(payload);
            } else {
                this.popupProduct = this.getProductData(this.product.id);
            }
        },
        getProductData(productId) {
            this.getProduct(
                productId,
                this.productUrl,
                null,
                (product) => {
                    this.returnDetails = {};
                    this.popupProduct = _.cloneDeep(product);
                    this.productUomOptions = [];
                    this.productUomLabels = {};
                    if (product instanceof VariableProduct) {
                        Object.values(product.uom).forEach((uom) => {
                            this.productUomLabels[uom.slug] = uom.name;
                            this.productUomOptions.push(uom.slug);
                        });
                        this.returnDetailColumns["uom"]["options"] = this.productUomOptions;
                        this.returnDetailColumns["uom"]["labels"] = this.productUomLabels;
                    } else {
                        this.returnDetailColumns["uom"]["options"] = [product.uom.slug];
                        this.productUomLabels[product.uom.slug] = product.uom.name;
                        this.returnDetailColumns["uom"]["labels"] = this.productUomLabels;
                    }
                },
                (error) => {
                    this.closePopup();
                }
            );
        },
        loadLineItems(payload, success, failure) {
            if (this.cartMode) {
                return;
            }
            if (!payload) {
                payload = {};
            }
            payload.params = payload.params ?? {};
            payload.params.product_id = this.product.id;
            if (this.product.type == "variable") {
                if (this.product.variations) {
                    payload.params.product_id = Object.keys(this.product.variations).join();
                } else {
                    payload.params.product_id = this.product.variation_ids.join();
                }
            }

            let documentStatusToInclude = [];
            documentStatusToInclude.push("invoice");
            documentStatusToInclude.push("temporary-invoice");
            documentStatusToInclude.push("delivery-order");

            let document_type = [];
            document_type.push("invoice");
            document_type.push("delivery_order");

            payload.params.company_id = this.companyId;
            payload.params.untransferred = true;
            // payload.params.document_type = "invoice";
            payload.params.document_type = document_type;
            payload.params.document_status_to_include = documentStatusToInclude;
            payload.params.isCustomSort = true;
            this.getDocumentLineItems(payload, (lineItems, pagination) => {
                this.returnDetails = {};
                this.returnDetailsPagination = pagination;
                let lineItemRecords = [];

                if (this.isSerialNumberEnable) {
                    lineItems.forEach((lineItem) => {
                        if (Object.values(lineItem.serial_number).length == 0) {
                            lineItemRecords.push(this.addNewRow(lineItem.id, lineItem, null, true));
                        } else {
                            lineItem.untransferred_serial_number.forEach((serialNumber) => {
                                if (payload.params.serial_number_not_transfered) {
                                    let regExp = new RegExp(payload.params.serial_number_not_transfered, "i");
                                    if (serialNumber.match(regExp)) {
                                        lineItemRecords.push(
                                            this.addNewRow(serialNumber, lineItem, serialNumber, true)
                                        );
                                    }
                                } else {
                                    lineItemRecords.push(this.addNewRow(serialNumber, lineItem, serialNumber, true));
                                }
                            });
                        }
                    });
                } else {
                    lineItems.forEach((lineItem) => {
                        lineItemRecords.push(this.addNewRow(lineItem.id, lineItem, null, true));
                    });
                }

                this.boProcessRecords(this.returnDetails, lineItemRecords);
            });
        },
        fetcLineItems(payload = null, success = null, failure = null) {
            this.loadLineItems(payload, success, failure);
        },
        fetchLineItemsIfNeeded() {
            if (this.returnDetails == null) {
                this.fetcLineItems();
            }
        },
        addNewRow(id, lineItem = null, serialNumber = null, isLoadLineItem = false) {
            // if (lineItem) {
            //     lineItem.product.selectUom(this.productUomOptions[0]);
            // }
            let newRowProduct = _.cloneDeep(this.popupProduct);
            let uomSlug = "";
            if (this.popupProduct instanceof VariableProduct) {
                newRowProduct.selectUom(this.productUomOptions[0]);
                uomSlug = newRowProduct.getSelectedUom().slug;
            } else if (this.popupProduct instanceof VariationProduct) {
                uomSlug = newRowProduct.uom.slug;
            }

            if (typeof newRowProduct.quantity == "undefined") {
                newRowProduct.quantity = 0;
            }

            let unitPrice = lineItem
                ? this.addOrRemoveTaxIfNeeded(lineItem.price, lineItem.tax_class)
                : this.addOrRemoveTaxIfNeeded(newRowProduct.getCurrentPrice(), newRowProduct.tax_class);

            let returnDetail = {
                product: newRowProduct,
                lineItem: lineItem,
                id: id,
                // display only: the TA formula behind discount_value, see getReturnDiscountSteps()
                discount_formula: null,
                discount_from_trade_agreement: false,
                uom: lineItem ? lineItem.product.uom.slug : uomSlug,
                price: unitPrice,
                tax_class: lineItem ? lineItem.tax_class : this.isTaxExempted ? null : newRowProduct.tax_class,
                quantity: newRowProduct.quantity,
                subtotal: unitPrice * newRowProduct.quantity,
                return_reason: null,
                remark: null,
                batch: this.isBatchEnable ? (lineItem ? lineItem.batch : null) : null,
                serial_number_not_transfered: this.isSerialNumberEnable ? serialNumber : null,
                document_number: lineItem ? lineItem.document_number : null,
                created_at: lineItem ? lineItem.created_at : null,
            };

            if (isLoadLineItem) {
                returnDetail["discount_type"] =
                    lineItem?.discounts && Object.values(lineItem?.discounts).length > 0
                        ? this.discountTypes[lineItem.discounts[0].type]
                        : this.defaultDiscountType;

                if (
                    lineItem?.discounts &&
                    Object.values(lineItem?.discounts).length > 0 &&
                    lineItem.discounts[0].type == "unit"
                ) {
                    returnDetail["discount_value"] = lineItem.discounts[0].value ?? 0;
                } else {
                    returnDetail["discount_value"] = lineItem
                        ? lineItem.total == lineItem.subtotal
                            ? 0
                            : (1 -
                                  parseFloat(
                                      (
                                          this.addTaxIfNeeded(lineItem.total, lineItem.tax_class) /
                                          this.addTaxIfNeeded(lineItem.subtotal, lineItem.tax_class)
                                      ).toFixed(6)
                                  )) *
                              100
                        : 0;
                }
                // hard code quantity to 1 when there is serial number
                if (serialNumber) {
                    returnDetail.quantity = 1;
                }
                return returnDetail;
            } else {
                returnDetail["discount_type"] = this.defaultDiscountType;
                returnDetail["discount_value"] = 0;
                this.$set(this.returnDetails, returnDetail.id, new Record(returnDetail));
                this.reloadTradeAgreementPrice();
            }
        },
        toNormalMode() {
            this.isBypassBinding = true;
            this.returnDetailColumns["uom"]["editable"] = true;
            this.returnDetailColumns["batch"]["editable"] = true;
            this.returnDetailColumns["batch"]["searchable"] = false;
            this.returnDetailColumns["serial_number_not_transfered"]["editable"] = true;
            this.returnDetailColumns["serial_number_not_transfered"]["searchable"] = false;
            this.returnDetailColumns["document_number"]["disabled"] = true;
            this.returnDetailColumns["document_date"]["disabled"] = true;
            this.returnDetailColumns["action"]["disabled"] = false;
            this.returnDetailsPagination = null;
            this.returnDetails = {};

            if (!this.cartMode) {
                this.addNewRow(this.indexCounter++);
            }
        },
        confirm() {
            if (this.cartMode) {
                this.$emit("update_cart_item", this.getCartItem());
                this.closePopup();
                return;
            }
            this.postAddToCart(
                this.cartUrl,
                this.addToCartPayload(),
                //Save product...
                () => {
                    alert("Added product to cart.");
                    this.closePopup();
                },
                () => alert("Error saving product.")
            );
            // this.closePopup();
        },
        deleteRow(returnDetailId) {
            this.$delete(this.returnDetails, returnDetailId);
        },
        returnDetailChange(returnDetailId, key, record) {
            if (key == "quantity") {
                this.returnDetailChangeQuntity(returnDetailId, record);
            } else {
                this.returnDetails[returnDetailId].checked = true;
                this.returnDetails[returnDetailId][key] = record;
            }
        },
        returnDetailChangeQuntity(returnDetailId, newQuantity) {
            if (typeof newQuantity != "undefined") {
                this.returnDetails[returnDetailId].quantity = parseFloat(newQuantity);
            } else {
                this.returnDetails[returnDetailId].quantity = 0;
            }

            if (!this.isDocumentBinding) {
                this.reloadTradeAgreementPrice();
            } else {
                this.returnDetails[returnDetailId].subtotal =
                    this.returnDetails[returnDetailId].quantity * this.returnDetails[returnDetailId].price;
            }

            if (this.returnDetails[returnDetailId].quantity <= 0) {
                this.returnDetails[returnDetailId].checked = false;
            } else {
                this.returnDetails[returnDetailId].checked = true;
            }
        },
        returnDetailChangeUom(returnDetailId, columnId, newUom) {
            this.returnDetails[returnDetailId].checked = true;
            this.returnDetails[returnDetailId].product.selectUom(newUom);
            this.returnDetails[returnDetailId].price = this.addOrRemoveTaxIfNeeded(
                this.returnDetails[returnDetailId].product.getCurrentPrice(),
                this.returnDetails[returnDetailId].tax_class
            );
            this.returnDetailChangeQuntity(returnDetailId);
        },
        returnDetailChangeSerialNumber(returnDetailId, key, record) {
            this.returnDetails[returnDetailId].checked = true;
            if (record != "") {
                this.returnDetails[returnDetailId].quantity = 1;
                this.returnDetailChangeQuntity(returnDetailId, 1);
            } else {
                this.returnDetails[returnDetailId].quantity = 0;
                this.returnDetailChangeQuntity(returnDetailId, 0);
            }
        },
        closePopup() {
            this.showPopup = false;
            this.isBypassBinding = false;
            this.returnDetailColumns = this.boDatatableProcessColumns(filterCatalogPriceColumns([
                {
                    id: "id",
                    label: window.bo?.catalogTranslations?.id ?? "ID",
                    disabled: true,
                    type: "text",
                    primary_key: true,
                },
                {
                    id: "price",
                    label: window.bo?.catalogTranslations?.price ?? "Unit Price (RM)",
                    type: "number",
                    orderable: false,
                    searchable: false,
                    decimal: 2,
                    transformer: (record) => {
                        if (this.isDocumentBinding) {
                            return (
                                this.addOrRemoveTaxIfNeeded(record.lineItem.subtotal, record.tax_class) /
                                record.lineItem.quantity
                            );
                        } else {
                            return record.price;
                        }
                    },
                },
                {
                    id: "tax_name",
                    label: window.bo?.catalogTranslations?.tax_name ?? "Tax Class",
                    type: "text",
                    orderable: true,
                    searchable: false,
                    transformer: (record) => {
                        return record.tax_class?.visible ? record.tax_class?.name : "";
                    },
                },
                {
                    id: "tax_percentage",
                    label: window.bo?.catalogTranslations?.tax_percentage ?? "Tax ",
                    type: "text",
                    orderable: true,
                    searchable: false,
                    editable: false,
                    transformer: (record) => {
                        return record.tax_class?.visible ? record.tax_class.percentage + "%" : "";
                    },
                },
                {
                    id: "uom",
                    label: window.bo?.catalogTranslations?.uom ?? "UOM",
                    type: "select",
                    nullText: "Select",
                    orderable: true,
                    searchable: false,
                    editable: this.salesReturnValidationMode != "document_binding",
                    options: this.productUomOptions,
                    labels: this.productUomLabels,
                },
                {
                    id: "quantity",
                    label: window.bo?.catalogTranslations?.quantity ?? "Return",
                    type: "number",
                    orderable: false,
                    searchable: false,
                    editable: true,
                    min: 0,
                    max: Number.MAX_SAFE_INTEGER,
                    negative: false,
                },
                {
                    id: "discount",
                    label: window.bo?.catalogTranslations?.discount ?? "Discount",
                    type: "custom",
                    orderable: false,
                    editable: false,
                    searchable: false,
                },
                {
                    id: "effective_unit_price",
                    label: window.bo?.catalogTranslations?.effective_unit_price ?? "Unit Price After Discount",
                    type: "number",
                    decimal: 2,
                    orderable: false,
                    editable: false,
                    searchable: false,
                    transformer: (record) => {
                        if (record.quantity > 0) {
                            return record.subtotal / record.quantity;
                        } else if (record.discount_type) {
                            return record.price;
                        }
                        return 0.0;
                    },
                },
                {
                    id: "subtotal",
                    label: window.bo?.catalogTranslations?.subtotal ?? "Subtotal (RM)",
                    type: "number",
                    orderable: false,
                    searchable: false,
                    decimal: 2,
                },
                {
                    id: "return_reason",
                    label: window.bo?.catalogTranslations?.return_reason ?? "Return Reason",
                    type: "select",
                    nullText: "Select",
                    orderable: false,
                    searchable: false,
                    editable: true,
                    options: this.returnReasonOptions,
                    labels: this.returnReasonLabels,
                    nullText: "Select",
                },
                {
                    id: "remark",
                    label: window.bo?.catalogTranslations?.remark ?? "Remark",
                    type: "text",
                    orderable: false,
                    searchable: false,
                    editable: true,
                },
                {
                    id: "batch",
                    label: window.bo?.catalogTranslations?.batch ?? "Batch",
                    type: "text",
                    orderable: true,
                    editable: this.salesReturnValidationMode != "document_binding",
                    disabled: !this.isBatchEnable,
                },
                {
                    id: "serial_number_not_transfered",
                    label: window.bo?.catalogTranslations?.serial_number_not_transferred ?? "Serial Number",
                    type: "text",
                    orderable: true,
                    editable: this.salesReturnValidationMode != "document_binding",
                    disabled: !this.isSerialNumberEnable,
                },
                {
                    id: "document_number",
                    label: window.bo?.catalogTranslations?.document_number ?? "Document Number",
                    type: "text",
                    orderable: true,
                    editable: false,
                    disabled: this.salesReturnValidationMode != "document_binding",
                },
                {
                    id: "document_date",
                    label: window.bo?.catalogTranslations?.document_date ?? "Document Date",
                    type: "datetime",
                    orderable: true,
                    editable: false,
                    searchable: true,
                    format: "DD-MMM-YYYY",
                    disabled: this.salesReturnValidationMode != "document_binding",
                    transformer: (record) => {
                        return record.lineItem.document_date;
                    },
                },
                {
                    id: "action",
                    label: window.bo?.generalTranslations?.action ?? "Action",
                    type: "custom",
                    orderable: false,
                    searchable: false,
                    disabled: this.salesReturnValidationMode == "document_binding",
                },
            ]));
            this.$emit("deactivate");
        },
        addToCartPayload() {
            var cartItems = new Array();
            Object.values(this.returnDetails).forEach((returnDetail) => {
                if (returnDetail.checked && returnDetail.quantity > 0) {
                    if (returnDetail.product instanceof VariableProduct && returnDetail.lineItem != null) {
                        cartItems.push({
                            mode: "return",
                            product_id: returnDetail.product.selected_variation_id,
                            quantity: returnDetail.quantity,
                            subtotal: returnDetail.subtotal,
                            total: returnDetail.subtotal,
                            line_item_id: returnDetail.lineItem.id,
                            return_reason: returnDetail.return_reason,
                            remark: returnDetail.remark,
                            batch: returnDetail.batch,
                            serial_numbers: [returnDetail.serial_number_not_transfered],
                        });
                    } else if (returnDetail.product instanceof VariableProduct) {
                        cartItems.push({
                            mode: "return",
                            product_id: returnDetail.product.selected_variation_id,
                            quantity: returnDetail.quantity,
                            subtotal: returnDetail.subtotal,
                            total: returnDetail.subtotal,
                            return_reason: returnDetail.return_reason,
                            remark: returnDetail.remark,
                            batch: returnDetail.batch,
                            serial_numbers: [returnDetail.serial_number_not_transfered],
                        });
                    } else if (returnDetail.lineItem != null) {
                        cartItems.push({
                            mode: "return",
                            product_id: returnDetail.product.id,
                            quantity: returnDetail.quantity,
                            subtotal: returnDetail.subtotal,
                            total: returnDetail.subtotal,
                            line_item_id: returnDetail.lineItem.id,
                            return_reason: returnDetail.return_reason,
                            remark: returnDetail.remark,
                            batch: returnDetail.batch,
                            serial_numbers: [returnDetail.serial_number_not_transfered],
                        });
                    } else {
                        cartItems.push({
                            mode: "return",
                            product_id: returnDetail.product.id,
                            quantity: returnDetail.quantity,
                            subtotal: returnDetail.subtotal,
                            total: returnDetail.subtotal,
                            return_reason: returnDetail.return_reason,
                            remark: returnDetail.remark,
                            batch: returnDetail.batch,
                            serial_numbers: [returnDetail.serial_number_not_transfered],
                        });
                    }
                }
            });
            return {
                id: this.cartId,
                outlet: this.outletId,
                items: cartItems,
            };
        },
        loadCartItem(item) {
            let newRowProduct = _.cloneDeep(this.popupProduct);
            newRowProduct.selectUom(this.productUomOptions[0]);
            newRowProduct.quantity = item.quantity;

            let unitPrice = this.cartItem?.line_item_id
                ? item.line_item.total / item.line_item.quantity
                : item.quantity > 0
                ? item.total / item.quantity
                : item.total;

            let returnDetail = {
                product: newRowProduct,
                lineItem: item.line_item,
                id: item.id,
                product_id: item.product_id,
                uom: item.product.getSelectedUom().slug,
                tax_class:
                    item?.line_item_id && item?.line_item.tax_class
                        ? item.line_item.tax_class
                        : this.isTaxExempted
                        ? null
                        : item.product.tax_class,
                price: unitPrice,
                quantity: item.quantity,
                subtotal: unitPrice * item.quantity,
                return_reason: item.return_reason,
                remark: item.remark,
                batch: this.isBatchEnable ? item.batch : null,
                serial_number_not_transfered: item.serial_numbers.length > 0 ? item.serial_numbers[0] : null,
                document_number: item.document_number,
                created_at: item.line_item ? item.line_item.created_at : null,
                discount_value: 0,
                discount_type: this.defaultDiscountType,
                discount_formula: null,
                discount_from_trade_agreement: false,
            };
            this.$set(this.returnDetails, returnDetail.id, new Record(returnDetail));
            this.reloadTradeAgreementPrice();
        },
        getCartItem() {
            let cartItem = this.returnDetails[this.cartItem.id];
            return {
                id: this.cartItem.id,
                product_id: this.cartItem.product_id,
                quantity: cartItem.quantity,
                subtotal: cartItem.subtotal,
                total: cartItem.subtotal,
                return_reason: cartItem.return_reason,
                remark: cartItem.remark,
                batch: cartItem.batch,
                serial_numbers: cartItem.serial_number_not_transfered ? [cartItem.serial_number_not_transfered] : [],
            };
        },
        addOrRemoveTaxIfNeeded(productPrice, taxClass) {
            if (this.isTaxExempted && this.isBypassBinding) {
                if (this.isTaxIncluded && taxClass) {
                    return productPrice / (1 + taxClass.percentage / 100);
                } else {
                    return productPrice;
                }
            } else {
                if (this.isTaxIncluded == this.isDisplayPricesDuringCartAndCheckoutIncludingTax || !taxClass) {
                    return productPrice;
                }
                if (this.isTaxIncluded && !this.isDisplayPricesDuringCartAndCheckoutIncludingTax) {
                    return productPrice / (1 + taxClass.percentage / 100);
                }
                if (!this.isTaxIncluded && this.isDisplayPricesDuringCartAndCheckoutIncludingTax) {
                    return productPrice * (1 + taxClass.percentage / 100);
                }
            }
        },
        reloadTradeAgreementPrice() {
            let payload = {
                customer_id: this.companyId,
                line_items: this.getItemsData(),
            };

            this.getCartTradeAgreementPrice(this.tradeAgreementUrl, payload, (tradeAgreementResult) => {
                Object.keys(tradeAgreementResult).forEach((key) => {
                    this.returnDetails[key].price = this.addOrRemoveTaxIfNeeded(
                        tradeAgreementResult[key].unit_price,
                        this.returnDetails[key].tax_class
                    );
                    this.returnDetails[key].discount_value = tradeAgreementResult[key].discount_value;
                    this.returnDetails[key].discount_formula = tradeAgreementResult[key].formula ?? null;
                    this.returnDetails[key].discount_from_trade_agreement = true;
                    if (tradeAgreementResult[key].type) {
                        switch (tradeAgreementResult[key].type) {
                            case "absolute":
                            case "complex":
                                this.returnDetails[key].discount_type = this.discountTypes["unit"];
                                break;
                            case "percentage":
                                this.returnDetails[key].discount_type = this.discountTypes["percentage"];
                                break;
                        }
                    }
                    this.returnDetails[key].subtotal = this.getDocumentLineItemTotal(this.returnDetails[key]);
                });
            });
        },
        // Discount levels for the Discount column, from the same source as discount_value (which prices the
        // return): the trade agreement formula when TA priced the row, else the linked line item's saved
        // discounts, else the row's single discount type / value.
        getReturnDiscountSteps(record) {
            const value = Number(record.discount_value) || 0;
            const fallbackFormula =
                value > 0 ? ((record.discount_type?.id ?? record.discount_type) === "percentage" ? `${value}%` : `${value}`) : null;

            if (!record.discount_from_trade_agreement && record.lineItem) {
                const steps = documentLineDiscountSteps(record.lineItem, this.currencySymbol);
                if (steps.length > 0) {
                    return steps;
                }
            }

            return formatLineDiscountSteps({
                formula: (record.discount_from_trade_agreement && record.discount_formula) || fallbackFormula,
                unitPrice: 0,
                regularPrice: 0,
                currencySymbol: this.currencySymbol,
            });
        },
        getItemsData() {
            let itemsData = [];
            Object.values(this.returnDetails).forEach((item) => {
                itemsData.push({
                    id: item.id,
                    product_id:
                        item.product instanceof VariableProduct ? item.product.selected_variation_id : item.product.id,
                    quantity: item.quantity,
                });
            });
            return itemsData;
        },
        getDocumentLineItemTotal(documentLineItem) {
            if (documentLineItem.product.type == "bundle") {
                return 0;
            }

            if (documentLineItem.quantity == 0) {
                return 0;
            }

            let lineItemTotal = documentLineItem.price * documentLineItem.quantity;

            if (!this.lineItemCustomDiscountEnabled) {
                if (documentLineItem.discount_value == 0) {
                    return lineItemTotal;
                }
                if (documentLineItem.discount_type.id == "percentage") {
                    return lineItemTotal * (1 - documentLineItem.discount_value / 100);
                }
                return lineItemTotal - documentLineItem.discount_value * documentLineItem.quantity;
            } else {
                let highestLevel = 0;
                this.lineItemCustomDiscount.forEach((discount, key) => {
                    if (key == 0) {
                        highestLevel = discount.level;
                    } else {
                        highestLevel = Math.max(highestLevel, discount.level);
                    }
                });
                for (let index = 1; index <= highestLevel; index++) {
                    let unit = 0;
                    this.lineItemCustomDiscount.forEach((discount) => {
                        if (discount.level == index) {
                            if (this.getSelectedCustomDiscountType(documentLineItem, discount).id == "percentage") {
                                unit +=
                                    Math.round(
                                        Math.round(
                                            lineItemTotal *
                                                (this.getDiscountValue(documentLineItem, discount.name) / 100) *
                                                1000
                                        ) / 10
                                    ) / 100;
                            } else if (this.getSelectedCustomDiscountType(documentLineItem, discount).id == "unit") {
                                unit +=
                                    this.getDiscountValue(documentLineItem, discount.name) * documentLineItem.quantity;
                            }
                        }
                    });
                    lineItemTotal = lineItemTotal - unit;
                }
                return lineItemTotal;
            }
        },
        getDiscountValue(record, discountName) {
            if (
                record[discountName] === undefined ||
                record[discountName].value === undefined ||
                record[discountName].value == ""
            ) {
                return 0;
            } else {
                return parseFloat(record[discountName].value);
            }
        },
        getSelectedCustomDiscountType(record, customDiscount) {
            if (record[customDiscount.name] === undefined || record[customDiscount.name].type === undefined) {
                if (customDiscount.allow_percentage_discount) {
                    return this.discountTypes["percentage"];
                } else if (customDiscount.allow_unit_discount) {
                    return this.discountTypes["unit"];
                }
            }

            return record[customDiscount.name].type;
        },
        addTaxIfNeeded(price, taxClass) {
            if (this.isTaxExempted && this.isTaxIncluded && taxClass) {
                var result = price / (1 + taxClass.percentage / 100);
                return result;
            }

            if (!taxClass || !this.isDisplayPricesDuringCartAndCheckoutIncludingTax || this.isTaxExempted) {
                return price;
            }

            var result = price * (1 + taxClass.percentage / 100);
            return result;
        },
        roundToDecimal(number, decimal = 2, getNumber = false) {
            if (getNumber) {
                return number.toFixed(decimal);
            }

            return parseFloat(number.toFixed(decimal));
        },
        getProductImage(images) {
            let image = "/assets/graphics/img-product.svg";

            if (typeof images != "undefined" && Object.values(images).length > 0) {
                if (
                    typeof Object.values(images)[0]["source_url_small"] != "undefined" &&
                    Object.values(images)[0]["source_url_small"] != ""
                ) {
                    image = Object.values(images)[0]["source_url_small"];
                }
            } else if (this.product.images != "") {
                image = this.product.images;
            }

            return image;
        },
        debugGeneralTranslations() {
            console.log("generalTranslations:", this.generalTranslations);
        },
    },
};
</script>
